import { render, staticRenderFns } from "./catDBusiness.vue?vue&type=template&id=3a20c7f6&scoped=true"
import script from "./catDBusiness.vue?vue&type=script&lang=js"
export * from "./catDBusiness.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a20c7f6",
  null
  
)

export default component.exports